import  {combineReducers} from 'redux'
import fetchDataReducer from './fetchdatareducer'
const rootReducer = combineReducers({
    fetchDataReducer
})
export default rootReducer